export default __webpack_public_path__ + "static/media/nightSnowEight.9ff99835.jpg";